import * as THREE from 'three'
import { ThreeComponet } from './types'
import vertexShader from './glsl/postEffect.vs'
import fragmentShader from './glsl/postEffect.fs'

interface PostEffectUniforms {
  time: THREE.IUniform<number>
  resolution: THREE.IUniform<THREE.Vector2>
  texture: THREE.IUniform<THREE.Texture>
  [uniform: string]: THREE.IUniform<any>
}

export default class PostEffect extends ThreeComponet<PostEffectUniforms> {
  timeScale: number

  constructor(texture: THREE.Texture) {
    super({
      time: {
        // type: 'f',
        value: 0,
      },
      resolution: {
        // type: 'v2',
        value: new THREE.Vector2(document.body.clientWidth, window.innerHeight),
      },
      texture: {
        // type: 't',
        value: texture,
      },
    })
    this.timeScale = 1
  }

  createObj(): THREE.Mesh {
    return new THREE.Mesh(
      new THREE.PlaneGeometry(2, 2),
      new THREE.RawShaderMaterial({
        uniforms: this.uniforms,
        vertexShader,
        fragmentShader,
      })
    )
  }

  render(time: number): void {
    this.uniforms.time.value += time * this.timeScale
  }

  resize(): void {
    this.uniforms.resolution.value.set(
      document.body.clientWidth,
      window.innerHeight
    )
  }
}
